class MixpanelCtrl
  constructor: ->
    @init()

  @start_session: ->
    return if process.env.NODE_ENV != 'production' || !Session.authorized
    return unless window.mixpanel?.track
    mixpanel.identify(Session.current_user.id)
    mixpanel.people.set({
      "$email": Session.current_user.email,
      "$created": Session.current_user.created_at,
      "$last_login": new Date(),
      name: Session.current_user.name
      company_name: Session.current_company.name,
      job_title: Session.current_user.roleDescription()
      email_service: Session.current_user.email_service,
      email_provider: if Session.current_user.isNylas() then Session.current_user.nylas_setting?.original_response?.provider else '',
      pipedrive: Session.current_user.pipedrive_setting?.stage_id != undefined,
      nectar: Session.current_user.nectar_setting?.id != undefined,
      salesforce: Session.current_user.salesforce_setting?.id != undefined,
      hubspot: Session.current_user.hubspot_setting?.id != undefined,
      rd_station: Session.current_user.rd_station_setting?.id != undefined,
      sharpspring: Session.current_user.sharpspring_setting?.id != undefined,
      leadlovers: Session.current_user.leadlovers_setting?.id != undefined,
      vtiger: Session.current_user.vtiger_setting?.id != undefined,
      webhooks: Session.current_user.webhooks?.id != undefined,
      email_send_response: Session.current_user.crm_setting?.bcc_send_email != undefined,
      company_has_voip: Session.current_company.voip_service,
      company_active: Session.current_company.active,
    })
    mixpanel.set_group("company", Session.current_company.name)
    mixpanel.get_group("company", Session.current_company.name).set({
      company_name: Session.current_company.name,
      company_has_voip: Session.current_company.voip_service,
      company_active: Session.current_company.active,
      email_service: Session.current_company.email_service,
    })
    mixpanel.track('session_start', MixpanelCtrl.profileData())

  @trackEvent: (event_name, event_meta_data) ->
    return if process.env.NODE_ENV != 'production' || !Session.authorized
    return unless window.mixpanel?.track
    MixpanelCtrl.start_session() unless Number.isInteger(window.mixpanel?.persistence?.props?.distinct_id)
    mixpanel.track(event_name, Object.assign(event_meta_data, MixpanelCtrl.profileData())) if window.mixpanel?.track

  @profileData: ->
    return {} unless Session.authorized
    {
      user_id: Session.current_user.id,
      job_title: Session.current_user.roleDescription(),
      email: Session.current_user.email,
      name: Session.current_user.name,
      created_at: Session.current_user.created_at,
      company_name: Session.current_company.name,
      company_has_voip: Session.current_company.voip_service,
      company_active: Session.current_company.active
    }

  @logout: ->
    return if process.env.NODE_ENV != 'production' || !Session.authorized
    mixpanel.reset() if window.mixpanel?.track

  init: ->
    self = this
    ((c, a) ->
      if !a.__SV
        b = window
        try
          d = undefined
          m = undefined
          j = undefined
          k = b.location
          f = k.hash

          d = (a, b) ->
            if (m = a.match(RegExp(b + '=([^&]*)'))) then m[1] else null

          f and d(f, 'state') and j = JSON.parse(decodeURIComponent(d(f, 'state')))
          'mpeditor' == j.action and b.sessionStorage.setItem('_mpcehash', f)
          history.replaceState(j.desiredHash or '', c.title, k.pathname + k.search)

        catch n
        l = undefined
        h = undefined
        window.mixpanel = a
        a._i = []

        a.init = (b, d, g) ->
          `var c`
          `var f`
          e = a

          c = (b, i) ->
            `var a`
            a = i.split('.')
            2 == a.length and b = b[a[0]]
            i = a[1]

            b[i] = ->
              b.push [ i ].concat(Array::slice.call(arguments, 0))
              return

            return

          if 'undefined' != typeof g then (e = a[g] = []) else (g = 'mixpanel')
          e.people = e.people or []

          e.toString = (b) ->
            `var a`
            a = 'mixpanel'
            'mixpanel' != g and (a += '.' + g)
            b or (a += ' (stub)')
            a

          e.people.toString = ->
            e.toString(1) + '.people (stub)'

          l = 'disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove'.split(' ')
          h = 0
          while h < l.length
            c e, l[h]
            h++
          f = 'set set_once union unset remove delete'.split(' ')

          e.get_group = ->
            `var a`
            `var b`
            `var d`
            `var c`

            a = (c) ->

              b[c] = ->
                call2_args = arguments
                call2 = [ c ].concat(Array::slice.call(call2_args, 0))
                e.push [
                  d
                  call2
                ]
                return

              return

            b = {}
            d = [ 'get_group' ].concat(Array::slice.call(arguments, 0))
            c = 0
            while c < f.length
              a f[c]
              c++
            b

          a._i.push [
            b
            d
            g
          ]
          return

        a.__SV = 1.2
        b = c.createElement('script')
        b.type = 'text/javascript'
        b.async = !0
        b.src = 'https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js'
        d = c.getElementsByTagName('script')[0]
        d.parentNode.insertBefore b, d
      return
    ) document, window.mixpanel or []
    mixpanel.init process.env.MIXPANEL_API_KEY, {
      loaded: ->
        MixpanelCtrl.start_session()
    }

module.exports = MixpanelCtrl



// WEBPACK FOOTER //
// ./src/libraries/mixpanel.coffee